
import menu from './menu.json'
import migration from './migration.json'

export const ca = {
  menu,
  migration,
  busquesLreaPrivada: 'Busques l\'Àrea privada?'
}
